export enum CreatorStreamType {
  Rtmp = "RTMP",
}
